import React from 'react';
import {Box, Typography, IconButton, Stack} from '@mui/material';
import MenuFoldOutlined from "@ant-design/icons/MenuFoldOutlined";
import Logo from "@/components/logo/inbriefFullWhiteR.svg";
import {useFullscreenChat} from "@/contexts/FullscreenContext";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import Button from "@mui/material/Button";

interface ChatHeaderProps {
    onClose: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({onClose}) => {

    const {setIsFullscreenChat, isFullscreenChat, openAgentConversation} = useFullscreenChat()

    return (
        <Box display={'flex'} data-tour={"ai_ask_drawer_button"} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
            <Stack direction={'row'} spacing={1}>
                <IconButton
                    aria-label="open drawer"
                    onClick={onClose}
                    edge="start"
                    color="secondary"
                    variant="light"
                    sx={(theme) => ({
                        color: 'text.primary',
                        bgcolor: 'transparent',
                        ...theme.applyStyles('dark', { bgcolor:'transparent' })
                    })}
                >
                    {<MenuFoldOutlined />}
                </IconButton>
                <Button
                    variant={'contained'}
                    aria-label="fullscreen"
                    onClick={() => {
                        setIsFullscreenChat((prev) => !prev)
                        openAgentConversation(false)
                    }}
                    endIcon={isFullscreenChat ? <FullscreenExitIcon/> : <FullscreenIcon />}
                    sx={(theme) => ({
                        color: 'text.primary',
                        bgcolor: 'text.primary',
                        ...theme.applyStyles('dark', {variant:'light', bgcolor:'text.secondary' })
                    })}>
                    Change Agent
                </Button>
            </Stack>
            <Typography>{isFullscreenChat ? "InBrief AI Assistant (Conversational Agent)" : "InBrief AI Assistant"}</Typography>
            {/*<Box
                component="img"
                src={Logo}
                alt="Logo"
                sx={{
                    width: 'auto',
                    height: '35px',
                    objectFit: 'contain',
                    display: 'block'
                }}
            />*/}
        </Box>
    );
};